<template>
  <div
    class="mt-1"
  >
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <span style="font-size:20px; color: #fff;">ตารางอุโมงค์ในสายทางแต่ละจุด</span>
      </b-col>
      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(wid)="data">
            <div>
              <b-link
                target="_blank"
                :href="`${data.item.tunnel_url}?token=${userData.token}`"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
            </div>
          </template>
          <!-- <template #cell(Traffic_Location)="data">
            {{ data.value }} จุด
          </template> -->
          <template #cell(traffic_light_connection_status)="data">
            <span
              v-if="data.value === 'connecting...'"
              style="color:yellow;"
            >{{ data.value }}</span>
            <span
              v-if="data.value === 'connected'"
              style="color:#11DF00;"
            >{{ data.value }}</span>
          </template>
          <template #cell(Total_Vehicle)="data">
            {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} คัน
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BLink,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BLink,
  },
  data() {
    return {
      fields: [
        {
          key: 'detail',
          label: 'รายละเอียด',
          class: 'text-center',
        },
        {
          key: 'wid',
          label: 'รายละเอียด',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      camconnect: [{
        Online: 'ออนไลน์', Offline: 'ออฟไลน์',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    console.log(this.userData.token)
    this.getMenuTunnel()
    this.interval = setInterval(() => {
      this.getMenuTunnel()
    }, 1000)
  },
  methods: {
    getMenuTunnel() {
      axios
        .post('/getMenuTunnelSub', { DeptID: this.$route.query.DeptID })
        .then(response => {
          if (this.userData.username === 'drr-ok') {
            this.items = response.data.filter(item => item.wid === 1249 || item.wid === 1361)
          } else {
            this.items = response.data
          }
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
</style>
